import * as Yup from 'yup';

const assignPickUpSchema = Yup.object()
  .shape({
    equipmentNumber: Yup.string().trim(),
    billOfLadingNumber: Yup.string().trim(),
    terminalNxtEntityId: Yup.string().trim(),
    identificationCode: Yup.string().trim(),
  })
  .test(
    'at-least-one',
    'At least one of Equipment Number, Bill of Lading Number, Terminal NxtEntityId, or Identification Code must be filled in.',
    function (value) {
      const { equipmentNumber, billOfLadingNumber, terminalNxtEntityId, identificationCode } =
        value;
      const isValid =
        !!equipmentNumber || !!billOfLadingNumber || !!terminalNxtEntityId || !!identificationCode;

      if (!isValid) {
        return this.createError({
          path: 'equipmentNumber',
        });
      }

      return true;
    }
  );

export default assignPickUpSchema;
